import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import { mapGetters } from 'vuex'
import { KForm, KFormInput, KFormNumber, KFormSelect, KFormSpinner } from '@kwixeo/form-vue'
import { BAlert, BCol, BFormGroup, BFormRow, BInputGroup, BRow } from 'bootstrap-vue'
import { FormModal, NumberMixin } from '@kwixeo/interface-vue'

@Component({
  components: {
    FormModal,
    BAlert, BFormRow, BRow, BInputGroup, BCol, BFormGroup,
    KForm, KFormInput, KFormSelect, KFormSpinner, KFormNumber
  },
  computed: {
    ...mapGetters('user', ['currency']),
    ...mapGetters('subscriptions', ['hasModule']),
  }
})
export default class ProductVariationForm extends Mixins(NumberMixin) {
  currency!: KwixeoFramework.Currency
  hasModule!: (key: string) => boolean

  @Prop({ required: true }) product!: KwixeoCatalog.Product
  @Prop({ default: null }) value!: KwixeoCatalog.ProductVariation|null
  @Prop({ default: false }) modal!: boolean

  private modalState = false
  private variation: Partial<KwixeoCatalog.ProductVariation> = {}

  get modalTitle (): string {
    return this.variation?.id ? 'Modification d\'une variation' : 'Ajout d\'une variation'
  }

  get formMethod (): string {
    return this.variation?.id ? 'PUT' : 'POST'
  }

  get formAction (): string {
    let url = '/catalog/product/' + this.product.id + '/variation'
    if (this.variation?.id) {
      url += '/' + this.variation.id
    }
    return url
  }

  get variationValuesUrl (): (id: number) => string {
    return (id: number) => '/catalog/variation/' + id + '/value'
  }

  get vatRate (): number {
    return this.product.vat_rate ? this.product.vat_rate.rate : 0
  }

  get variationValue (): (value: string|undefined|null|KwixeoCatalog.VariationValue) => null|string {
    return (value: string|undefined|null|KwixeoCatalog.VariationValue): null|string => {
      if (typeof value === 'string') {
        return value
      } else if (value === null || value === undefined) {
        return null
      } else {
        return value.value
      }
    }
  }

  @Watch('modal')
  private watchModal (): void {
    this.modalState = this.modal
  }

  @Watch('value')
  private watchValue (): void {
    this.variation = this.value ? JSON.parse(JSON.stringify(this.value)) : {}
  }

  private calculUnitPrices (mode: string): void {
    let ttc = 0
    let tva = 0
    let ht = 0
    if (mode === 'ttc') {
      ttc = this.number(this.variation?.unit_price_ttc)
      ht = this.roundNumber(ttc / (1 + (this.vatRate / 100)), 5)
      tva = ttc - ht
    } else {
      ht = this.number(this.variation?.unit_price_ht)
      tva = this.roundNumber(ht * (this.vatRate / 100), 2)
      ttc = ht + tva
    }
    if (this.variation) {
      this.variation.unit_price_ht = ht
      this.variation.unit_price_tva = tva
      this.variation.unit_price_ttc = ttc
    }
  }

  private submitComplete (response: AxiosResponse): void {
    this.$emit('submitComplete', response.data)
  }
}
